export const APP_TITLE_DASHBOARD = 'Dashboard - AXPX Web App';
